import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const CommonDiv = styled.div`
  margin: 8px 0 20px 0;
`
export const TotalTimeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
  margin-bottom: 8px;
`
export const TotalOfferText = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: 15px;
  line-height: 18px;
  color: #4D566E;
  margin-bottom: 13px;
`
